module.exports = __webpack_public_path__ + "static/media/temp_w_domu_off_2.c4e559c6.svg";